import React from 'react';
import size from 'lodash';
import TooltipWrapper from '../TooltipWrapper';

function ListItemTip(props) {
  const {
    text = '',
    hintText = '',
    maxTextSize = 25,
    optClass = '',
    hideHighlight = false,
    child = null,
  } = props;
  const textSize = size(text);
  const tipDiv = <div className="chargers-autocomplete-tooltip">{hintText || text}</div>;
  const children = child || text;

  return (
    textSize > maxTextSize
      ? (
        <TooltipWrapper
          hideHighlight={hideHighlight}
          position="top-end"
          tip={tipDiv}
        >
          <div className={optClass}>{children}</div>
        </TooltipWrapper>
      )
      : <div className={optClass}>{children}</div>
  );
}

export default ListItemTip;
